module.exports = __webpack_public_path__ + "img/icon-marker-poi.c70b402f.svg";